<template>
  <slot></slot>
  <div>
    <modal :id="modalId" :title="title">
      <form :id="formId" :action="action" method="POST">

        <p class="text-center">Are you sure you want to delete {{ count }} form{{ count > 1 ? 's' : '' }}?</p>

        <input type="hidden" name="bulk_operation" :value="operation">
        <input type="hidden" v-for="id in checkedIds()" name="form_ids[]" :value="id">

        <input type="hidden" name="_method" value="PATCH">
        <input type="hidden" name="_token" :value="$csrf_token">
      </form>

      <template #footer>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>

    </modal>
  </div>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../stores/checkboxList"

export default {

  /**
   *
   * Confirmation modal dialog for forms deletion.
   *
   * Input properties:
   *
   * modalId - custom id for modal component
   * action - URL of bulk operation
   *
   * Usage examples:
   *
   * <form-bulk-modal action="..." group-id="..." operation="delete-forms">
   *    <button type="button" title="Delete forms" v-modal="'form-bulk-modal'">
   *       <i class="fa fa-trash"></i>
   *    </button>
   * </form-bulk-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id
    modalId: {
      type: String,
      default: 'form-bulk-modal'
    },

    // URL of bulk operation
    action: {
      type: String,
      default: ""
    },

    // Bulk operation.
    operation: {
      type: String,
      required: true
    },

  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds', 'checkedCount']),

    // Title of confirmation modal dialog
    title() {
      return 'Delete Forms';
    },

    // Count of selected forms/guidelines
    count() {
      return this.checkedCount();
    },

    formId() {
      return this.modalId + '-form';
    }

  }
}
</script>
